export default __webpack_public_path__ + "static/media/selpteam.d1e9dd27.png";